module.exports = __webpack_public_path__ + "img/target.b9421b89.svg";